var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5389 5.31452C14.3364 5.16152 14.094 4.95283 13.6524 4.90052C13.2384 4.8482 12.8166 5.11314 12.5314 5.28864C12.2462 5.46358 11.7073 5.97883 11.4846 6.1352C11.2618 6.29214 10.6914 6.43783 9.77344 6.96377C8.85544 7.4897 5.25375 9.69752 5.25375 9.69752L6.19144 9.70877L2.01206 11.7647H2.42944L1.82812 12.2012C1.82812 12.2012 2.35913 12.3356 2.80463 12.0668V12.19C2.80463 12.19 7.78106 10.3168 8.74237 10.8023L8.15625 10.966C8.20687 10.966 9.15188 11.0261 9.15188 11.0261C9.15188 11.0261 9.18337 11.5892 9.75375 11.9509C10.3241 12.3092 10.3359 12.5072 10.3359 12.5072C10.3359 12.5072 10.0389 12.6225 10.0389 12.7682C10.0389 12.7682 10.4766 12.6411 10.8827 12.6523C11.2888 12.6636 11.6443 12.7682 11.6443 12.7682C11.6443 12.7682 11.6134 12.6113 11.2185 12.5072C10.8203 12.3986 10.4338 11.992 10.242 11.7681C10.1256 11.628 10.0492 11.459 10.0211 11.2791C9.99298 11.0991 10.0141 10.9149 10.0822 10.746C10.2189 10.4068 10.6954 10.2201 11.6798 9.7352C12.8396 9.16033 13.1057 8.73508 13.2694 8.4032C13.4336 8.07133 13.6755 7.41095 13.8127 7.10102C13.9843 6.70164 14.1952 6.48902 14.3713 6.36245C14.5429 6.23533 15.3281 5.95577 15.3281 5.95577C15.3281 5.95577 14.7302 5.45964 14.5389 5.31452Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsm);
export default __webpack_public_path__ + "static/media/ksm.0e46f58fda60aab1619840f9fabb9c7e.svg";
export { ForwardRef as ReactComponent };